import(/* webpackMode: "eager", webpackExports: ["AboutPage"] */ "/app/src/features/about/pages/AboutPage.tsx");
